// extracted by mini-css-extract-plugin
export default {"scrollableList":"Sidebar_scrollableList__kyJRy","theme-violet":"Sidebar_theme-violet__TNvKZ"};